import React from 'react';
import styled from 'styled-components';

import FullStarIcon from 'assets/full-star';

export const FILLED_STAR_COLOR = '#F5A623';
export const EMPTY_STAR_COLOR = '#D2D7DA';

type FractionalStarProps = {
  /** Portion of the star filled gold, 0-100 (the rest renders grey). */
  fillPercent: number;
  size?: number;
  className?: string;
  /** Optional overlay content (e.g. interactive hit targets) positioned over the star. */
  children?: React.ReactNode;
};

/**
 * A single star filled to an arbitrary percentage — a grey `assets/full-star`
 * with a gold copy clipped to `fillPercent`. Shared by the read-only
 * `StarRating` display and the interactive `StarRatingInput`.
 */
export const FractionalStar = ({ fillPercent, size = 16, className, children }: FractionalStarProps): JSX.Element => (
  <Star $size={size} className={className}>
    <FullStarIcon fill={EMPTY_STAR_COLOR} width={`${size}px`} height={`${size}px`} />
    <Clip $percent={Math.min(100, Math.max(0, fillPercent))}>
      <FullStarIcon fill={FILLED_STAR_COLOR} width={`${size}px`} height={`${size}px`} />
    </Clip>
    {children}
  </Star>
);

const Star = styled.span<{ $size: number }>`
  position: relative;
  display: inline-flex;
  line-height: 0;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
`;

const Clip = styled.span<{ $percent: number }>`
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  line-height: 0;
  width: ${({ $percent }) => $percent}%;
`;
